var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0282 16.0375H6.55673C5.98299 16.0375 5.47656 16.4718 5.47656 17.0485V22.3754C5.47656 22.952 5.98299 23.3864 6.55673 23.3864H14.0282C14.602 23.3864 15.1084 22.952 15.1084 22.3754V17.0485C15.1084 16.4718 14.602 16.0375 14.0282 16.0375ZM13.7782 22.1254H6.80673V17.2985H13.7782V22.1254Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.443 6.75H17.9715C17.3978 6.75 16.8914 7.18434 16.8914 7.76099V13.0879C16.8914 13.6645 17.3978 14.0989 17.9715 14.0989H25.443C26.0168 14.0989 26.5232 13.6645 26.5232 13.0879V7.76099C26.5232 7.18434 26.0168 6.75 25.443 6.75ZM25.193 12.8379H18.2215V8.01099H25.193V12.8379Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0282 6.75H6.55673C5.98299 6.75 5.47656 7.18434 5.47656 7.76099V13.0879C5.47656 13.6645 5.98299 14.0989 6.55673 14.0989H14.0282C14.602 14.0989 15.1084 13.6645 15.1084 13.0879V7.76099C15.1084 7.18434 14.602 6.75 14.0282 6.75ZM13.7782 12.8379H6.80673V8.01099H13.7782V12.8379Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.443 15.8818H17.9715C17.3978 15.8818 16.8914 16.3162 16.8914 16.8928V22.2197C16.8914 22.7964 17.3978 23.2307 17.9715 23.2307H25.443C26.0168 23.2307 26.5232 22.7964 26.5232 22.2197V16.8928C26.5232 16.3162 26.0168 15.8818 25.443 15.8818ZM25.193 21.9697H18.2215V17.1428H25.193V21.9697Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.cf440ca9727f087f1f5e32528c3bd10e.svg";
export { ForwardRef as ReactComponent };